export default __webpack_public_path__ + "static/media/electric.8c488a11.png";